import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { INavigationItem } from '@app/main/interfaces';
import { NavigationService } from '@app/main/navigation.service';
import { AuthService } from '@app/shared/services/auth/auth.service';
import { UtilService } from '@app/shared/services/utils/util.service';
import { HelpComponent } from '../help/help.component';
import { HeaderFeedbackComponent } from '../header-feedback/header-feedback.component';

@Component({
  selector: 'cm-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
})
export class NavigationItemComponent implements OnInit {
  @Input() public navigationItem: INavigationItem;
  @Input() public isOverview: boolean;
  @Input() public isProfile: boolean;
  @Input() showFavorite: boolean;
  public isHover: boolean;

  constructor(
    private navigationService: NavigationService,
    private authService: AuthService,
    public dialog: MatDialog
  ) {}

  public ngOnInit(): void {
    this.navigationService.selectedNav.subscribe((navItem) => {
      if (!navItem.items && UtilService.isMobileAndTabletSize()) {
        this.navigationService.sidenavState.next(false);
      }
    });
  }

  public showHelpPopup(): void {
    this.dialog.open(HelpComponent, {
      panelClass: 'cm-header-pop-up',
      width: '100%',
      maxWidth: '334px',
      minHeight: '237px',
    });
  }

  public openFeedbackDialog(): void {
    this.dialog.open(HeaderFeedbackComponent);
  }

  public clickHandler(): void {
    switch (this.navigationItem.key) {
      case 'logout':
        this.authService.logout();
        break;
      case 'help':
        this.showHelpPopup();
        break;
      case 'feedback':
        this.openFeedbackDialog();
        break;
      default:
        break;
    }
  }

  onFavoriteToggle($event) {
    this.navigationItem.isMarkedAsFavorite = !this.navigationItem.isMarkedAsFavorite;
    this.navigationService.saveFavorite(this.navigationItem);
    $event.stopPropagation();
  }
}
